<template>
  <div class="breadcrumbs-container">
    <Breadcrumbs :crumbs="crumbs" link-component="SmartLink" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumbs from '@sephora-asia/core-breadcrumbs/Breadcrumbs.vue'
import pluralize from 'pluralize'

export default {
  name: 'BreadcrumbsContainer',

  components: {
    Breadcrumbs
  },

  props: {
    entityType: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      brand: 'listingPageBrand/brand',
      categories: 'listingPageFilters/categoryFilters'
    }),
    crumbs() {
      if (this.entityType === 'search') {
        return [{ name: this.$route.query.q }]
      }

      const crumbs = []
      const params = { ...this.$route.params }
      const categorySlugUrl = []
      let entityPath = `${pluralize(this.entityType)}`

      if (params.id) {
        entityPath = `${entityPath}/${this.brand.slugUrl}`

        crumbs.push({
          name: this.brand.name,
          path: `/${entityPath}`
        })
      }

      delete params.id

      // Looping through the categories params to identify and fetch the category from store
      Object.values(params).every((slugUrl) => {
        // for mapping the right format for slugUrl,
        // eg topCategory > makeup, category > makeup/face instead of just face
        categorySlugUrl.push(slugUrl)
        const category = this.categories.find(
          (category) => category.slugUrl === categorySlugUrl.join('/')
        )

        if (!category) {
          return
        }

        crumbs.push({
          name: category.label,
          path: `/${entityPath}/${category.slugUrl}`
        })

        return true
      })

      return crumbs
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbs-container {
  margin-bottom: 10px;

  ::v-deep nav {
    ol {
      padding: 0;
      margin: 0;
    }
  }
}
</style>
